import MasterDataTable from './MasterDataTable.vue';
import MpptQuickBuild from './MpptQuickBuild.vue';
export default {
  name: 'MpptStringMapPanel',
  components: {
    MasterDataTable: MasterDataTable,
    MpptQuickBuild: MpptQuickBuild
  },
  props: {
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      quickOpen: false
    };
  },
  methods: {
    onImported: function onImported() {
      this.$refs.table.load();
      // 上層的案場下拉會標「已有幾列」
      this.$emit('changed');
    }
  }
};